import React from 'react';
import { MLabel, MIcon } from 'src/theme';
import { PATH_LOGISTIC } from 'src/routes/paths';

import HomeIcon from '@material-ui/icons/Home';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '@iconify/react';
import bxHome from '@iconify/icons-bx/bx-home';
import fileInvoice from '@iconify/icons-la/file-invoice';
import outlineAssignmentReturn from '@iconify/icons-ic/outline-assignment-return';
import deliveryTruck from '@iconify/icons-carbon/delivery-truck';
import emailIcon from '@iconify/icons-carbon/email';

// ----------------------------------------------------------------------

const path = (name) => `/static/icons/navbar/${name}.svg`;

const ICONS = {
  home: <Icon icon={bxHome} style={{ width: '2em', height: '2em'}}/>,
  order: <Icon icon={fileInvoice} style={{ width: '2em', height: '2em'}}/>,
  rma: <Icon icon={outlineAssignmentReturn} style={{ width: '2em', height: '2em'}}/>,
  shipment: <Icon icon={deliveryTruck} style={{ width: '2em', height: '2em'}}/>,
  email: <Icon icon={emailIcon} style={{ width: '2em', height: '2em'}}/>
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'home',
        icon: ICONS.home,
        href: PATH_LOGISTIC.general.root
      }
    ]
  },
  {
    subheader: 'sales',
    items: [
      {
        title: 'order',
        icon: ICONS.order,
        href: PATH_LOGISTIC.general.invoice
      },
      {
        title: 'RMA',
        icon: ICONS.rma,
        href: PATH_LOGISTIC.general.rma
      },
      {
        title: 'shipment',
        icon: ICONS.shipment,
        href: PATH_LOGISTIC.general.shipment
      }
    ] 
  },
  {
    subheader: 'settings',
    items: [
      {
        title: 'email',
        icon: ICONS.email,
        href: PATH_LOGISTIC.general.email
      }
    ]
  }
];

export default navConfig;
